import { useEffect } from 'react';
import { useTranslation as useTranslationi18n } from 'react-i18next';
import { i18n } from '.';
import { useLanguage } from '@tenderd/track-web-utils';

export function useTranslation() {
    const { language } = useLanguage();
    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language]);
    const v = useTranslationi18n('common', { i18n: i18n as any });
    return v;
}
